/*
 * @Description: 请输入....
 * @Author: zyk
 * @Date: 2021-01-24 17:40:01
 * @LastEditTime: 2021-01-24 17:52:00
 * @LastEditors: zyk
 */
import React, { memo } from 'react'
 import { Wrap } from './style';
 export default memo(function ResultCpn() {
   return (
     <Wrap>
        <header>
          <img src={require('../../../assets/img/result.png').default} alt=""></img>
        </header>
     </Wrap>
   )
 })
 